'use strict';
module.exports = {
    ACCOUNT_ASSIGNMENT_DETAIL: {
        id: 'ACCOUNT_ASSIGNMENT_DETAIL',
        templatePath: `./${BUILD_PATH}/account-assignment-detail.dialog.html`
    },
    BPMN_DISPLAY: {
        id: 'BPMN_DISPLAY',
        templatePath: `./${BUILD_PATH}/bpmn-display.dialog.html`
    },
    CLIENT_WAREHOUSE_INSERT: {
        id: 'CLIENT_WAREHOUSE_INSERT',
        templatePath: `./${BUILD_PATH}/insert-into-warehouse.dialog.html`
    },
    ORDER_CONFIRMATION_CREATE: {
        id: 'ORDER_CONFIRMATION_CREATE',
        templatePath: `./${BUILD_PATH}/order-confirmation-create.dialog.html`
    },
    MATERIAL_GROUP_SELECTION: {
        id: 'MATERIAL_GROUP_SELECTION',
        templatePath: `./${BUILD_PATH}/material-group-selection.dialog.html`
    },
}
